import { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import EventListener from 'react-event-listener';
import { bindActionCreators } from 'redux';
import find from 'lodash/find';
import { updateStoreBreakpoint } from '../actions/app';
import isServer from '../utils/isServer';
import {
  XXLARGE,
  XLARGE,
  LARGE,
  MEDIUM,
  SMALL,
  XSMALL,
  BREAKPOINT_360,
  MIN,
} from '../styles/breakpoints';
import { WINDOW_RESIZE_DEBOUNCE_TIMEOUT } from '../constants/breakpoints';
import { selectBreakpoint, selectIsMobile } from '../selectors/app';

// must be large to small
const breakpoints = [
  XXLARGE,
  XLARGE,
  LARGE,
  MEDIUM,
  SMALL,
  XSMALL,
  BREAKPOINT_360,
  MIN,
];

export const mapStateToProps = (state) => ({
  isMobile: selectIsMobile(state),
  breakpoint: selectBreakpoint(state),
});

export function mapDispatchToProps(dispatch) {
  return {
    updateStoreBreakpoint: bindActionCreators(updateStoreBreakpoint, dispatch),
  };
}

export default function withBreakpoints(WrappedComponent) {
  class WithBreakPoints extends Component {
    static propTypes = {
      breakpoint: PropTypes.number,
      isMobile: PropTypes.bool.isRequired,
      updateStoreBreakpoint: PropTypes.func.isRequired,
    };

    constructor(props) {
      super(props);

      if (!isServer()) {
        this.updateBreakpoint();
      }
    }

    componentWillUnmount() {
      clearTimeout(this.deferTimer);
    }

    getBreakpoint() {
      const innerWidth = window.innerWidth;
      return find(breakpoints, (b) => innerWidth >= b);
    }

    updateBreakpoint() {
      const { breakpoint, updateStoreBreakpoint: updateBreakpoint } =
        this.props;
      const currentBreakpoint = this.getBreakpoint();

      if (currentBreakpoint !== breakpoint) {
        updateBreakpoint(currentBreakpoint);
      }
    }

    handleResize = () => {
      clearTimeout(this.deferTimer);

      this.deferTimer = setTimeout(() => {
        this.updateBreakpoint();
      }, WINDOW_RESIZE_DEBOUNCE_TIMEOUT);
    };

    render() {
      return (
        <EventListener target="window" onResize={this.handleResize}>
          <WrappedComponent {...this.props} />
        </EventListener>
      );
    }
  }

  return connect(mapStateToProps, mapDispatchToProps)(WithBreakPoints);
}
